import { Injectable } from '@angular/core';

export type KalColumnResizeDefinition = { code: string, initialWidth: number, currentWidth: number };

@Injectable()
export class KalTableColumnResizeService {
    private _resizedColumnList: KalColumnResizeDefinition[] = [];

    updateResizedColumn(resizedColumn: KalColumnResizeDefinition): void {
        const list = this.resizedColumnList;

        const index = list.findIndex((e) => e.code === resizedColumn.code);
        if (index === -1) {
            this._resizedColumnList.push(resizedColumn);
        } else {
            this._resizedColumnList[index] = {
                ...resizedColumn,
                initialWidth: list[index].initialWidth // l'initialWidth ne doit pas changer si elle est déjà définie.
            };
        }
    }

    get resizedColumnList(): KalColumnResizeDefinition[] {
        return this._resizedColumnList;
    }
}
